import React from "react";

export default () => {
  return <div className="no-data">No data results</div>;
};
